import { Component, OnChanges, Input, Renderer2, ElementRef } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { encapsulation } from '../../encapsulation';
import { UBXField, UBXFieldMessageEnum, UBXFieldErrorEnum } from '../../../models';

@Component({
    selector: 'ubx-field-message',
    templateUrl: './field-message.component.html',
    host: { class: 'ubx-field-message flx fs:3xs' },
    encapsulation,
    animations: [
        trigger('fadeIn', [
            transition(':enter', [
                style({ opacity: 0 }), animate('0.5s ease-in', style({ opacity: 1 }))
            ]),
        ]),
    ],
})
export class UBXFieldMessageComponent implements OnChanges {
    @Input() field: UBXField;
    @Input() value: any;

    Message = UBXFieldMessageEnum;
    Error = UBXFieldErrorEnum;

    constructor(
        private renderer: Renderer2,
        private el: ElementRef,
    ) {}

    ngOnChanges() {
        this.setAlignment(this.field.message?.align);
        this.messageCheck(this.field);
        this.errorCheck(this.field);
    }

    private setAlignment(align: string) {
        const value = align ? align : 'fe';
        this.appendClass(`f-jc:${value}`);
    }

    setAccent(accent: string): string {
        const color = accent ? accent : 'lte';
        const weight = '-300';
        return `clr:${color + weight}`;
    }

    setValue(value: string | number): number {
        return value ? value.toString().length : 0;
    }

    messageCheck(field: UBXField): boolean {
        return field.message && !field.error?.show ? true : false;
    }
    errorCheck(field: UBXField): boolean {
        return field.error && (field.message === undefined || !field.message?.show) ? true : false;
    }

    private appendClass(names: string) {
        this.renderer.addClass(this.el.nativeElement, names);
    }
}
